// extracted by mini-css-extract-plugin
module.exports = {"container":"CombinedOccupancy_container__wQ3IA","totalCapacityBox":"CombinedOccupancy_totalCapacityBox__7vxh6"};